
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 107 93","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.5 3.354L3.542 89.646h99.917L53.5 3.354z","stroke":"#0064FF","stroke-width":"6","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M53.5 71.48v2.27m0-38.604l.019 22.708","stroke":"#0064FF","stroke-width":"6","stroke-linecap":"round"}})])
          )
        }
      }
    